export function isBlank(str) {
  if (str === undefined || str === null) {
    return true;
  }

  if (typeof str !== 'string') {
    return false;
  }

  return str.trim().length === 0;
}

// 数字转大写
export const toChineseNumber = (num: number): string => {
  const chineseNumbers = '零一二三四五六七八九十';
  return chineseNumbers[num];
};


/**
 * 超出指定长度的字符串添加省略号
 * @param str 原始字符串
 * @param maxLength 最大长度（默认 10）
 * @returns 处理后的字符串（带省略号）
 */
export function truncateWithEllipsis(str: string, maxLength = 10): string {
  if (typeof str !== 'string') return '';
  return str.length > maxLength ? str.slice(0, maxLength) + '…' : str;
}